/*!

=========================================================
* Light Bootstrap Dashboard PRO React - v2.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

//WMP IMPORTS
import SiteDetails from "./views/Pages/SiteDetails";
import Dashboard from "./views/Pages/Dashboard";
import Account from "./views/Pages/Account";
import Site from "./views/Pages/Site";
import PageHistory from "./views/Pages/PageHistory";
import AddSite from "./views/Pages/AddSite";
import AdminData from "./views/Pages/AdminData";

// title: used for breadcrumb and document title
// breadcrumbParent: { label, path } for nested pages (e.g. Site > back to Dashboard)
let routes = [
  {
    path: "dashboard",
    layout: "/",
    name: "Dashboard",
    title: "Sites",
    icon: "fa-thin fa-monitor-waveform",
    component: Dashboard,
    reload: true,
  },
  {
    path: "site",
    layout: "/",
    name: "Site",
    title: "Pages",
    icon: "fa-thin fa-list-tree",
    component: Site,
    hidden: true,
    reload: false,
    breadcrumbParent: { label: "Sites", path: "/dashboard" },
  },
  {
    path: "account",
    layout: "/",
    name: "Account",
    title: "Account",
    icon: "fa-thin fa-user",
    component: Account,
    reload: false,
  },
  {
    path: "addsite",
    layout: "/",
    name: "Add Site",
    title: "Add site",
    icon: "fa-thin fa-plus-circle",
    component: AddSite,
    reload: false,
  },
  {
    path: "pagehistory",
    layout: "/",
    name: "Page History",
    title: "Page history",
    icon: "fa-thin fa-rectangle-history",
    component: PageHistory,
    hidden: true,
    reload: false,
    breadcrumbParent: { label: "Sites", path: "/dashboard" },
  },
  {
    path: "sitedetails",
    layout: "/",
    name: "Site Details",
    title: "Site details",
    icon: "fa-thin fa-gear",
    component: SiteDetails,
    hidden: true,
    reload: false,
    breadcrumbParent: { label: "Sites", path: "/dashboard" },
  },
  {
    path: "admindata",
    layout: "/",
    name: "Admin Data",
    title: "Admin Data",
    icon: "fa-thin fa-chart-mixed",
    component: AdminData,
    hidden: true,
    reload: false,
  },
];
export default routes;
